import type { SxProps } from '@mui/material';
import { DateScale } from '@/shared/types';
import { Select } from '../Select/Select';

const ITEMS: { value: DateScale; label: string }[] = [
  { value: DateScale.DAY, label: 'Daily' },
  { value: DateScale.WEEK, label: 'Weekly' },
  { value: DateScale.MONTH, label: 'Monthly' },
  { value: DateScale.THREE_DAYS, label: '3 days' },
  { value: DateScale.SEVEN_DAYS, label: '7 days' },
  { value: DateScale.FOURTEEN_DAYS, label: '14 days' },
  { value: DateScale.THIRTY_DAYS, label: '30 days' },
];

interface Props {
  sx?: SxProps;
  label?: string;
  disabled?: boolean;
  value: DateScale;
  onChange: (v: DateScale) => void;
}

export function DateScaleSelect({
  sx,
  label,
  disabled,
  value,
  onChange,
}: Props) {
  return (
    <Select
      sx={sx}
      selectProps={{ disabled }}
      label={label ?? 'Date Scale'}
      options={ITEMS}
      value={value}
      onChange={onChange}
    />
  );
}
